import * as actions from './events/actions'
import * as mutations from './events/mutations'
import * as getters from './events/getters'

import { basicProps, guestFormProps } from './events/properties'

const state = {
    filterText: '',
    list: [],
    props: JSON.parse(JSON.stringify(basicProps)),
    bookedDateList: [],
    selectedMonthYear: {
        month: new Date().getMonth() + 1,
        year: new Date().getFullYear()
    },
    guests: {
        rawList: [],
        show_guest_window: false,
        list: [],
        recipe_list: [],
        props: JSON.parse(JSON.stringify(guestFormProps))
    },
    table_list: [],
    table_loading: false,
    table_cloth_list: [],
    event_type: [],
    cake_list: [],
    loading: false,
    day_schedule_edit: false,
    observation_edit: false
}

export default {
    state,
    actions,
    mutations,
    getters
}


// WEBPACK FOOTER //
// ./src/store/modules/events.js